import React, { useState } from 'react';
import { Box, Button, Typography } from '@material-ui/core';
import { Header } from '../../../components/Header';
import ProvisionStepper from '../provisionStepper';
import Icon from '../../../utils/icons';
import I18n from '../../../localization';
import makeStyle from './installationGuideStyles';
import { evaluate } from './wiringEngine';
import { IQ_AIR_CONTACT_SUPPORT,PAGES } from '../../../utils/constant';


const STEPS = {
    INTRO: 'INTRO',
    WHATS_IN_BOX: 'WHATS_IN_BOX',
    TOOLS_NEEDED: 'TOOLS_NEEDED',
    TURN_OFF_HVAC: 'TURN_OFF_HVAC',
    HVAC_POWER_ERROR: 'HVAC_POWER_ERROR',
    TAKE_PHOTO: 'TAKE_PHOTO',
    PHOTO_ERROR: 'PHOTO_ERROR',
    HIGH_VOLTAGE: 'HIGH_VOLTAGE',
    HIGH_VOLTAGE_ERROR: 'HIGH_VOLTAGE_ERROR',
    JUMPER_WIRES: 'JUMPER_WIRES',
    REMOVE_JUMPERS: 'REMOVE_JUMPERS',
    DUAL_LABELS: 'DUAL_LABELS',
    HEAT_PUMP_CHECK: 'HEAT_PUMP_CHECK',
    TERMINAL_SELECTION: 'TERMINAL_SELECTION',
    UNCOMMON_WIRING: 'UNCOMMON_WIRING',
    K_TERMINAL: 'K_TERMINAL',
    UNRECOGNIZED: 'UNRECOGNIZED',
    POWER_PLATE: 'POWER_PLATE',
    REMOVE_THERMOSTAT: 'REMOVE_THERMOSTAT',
    INSTALL_TRIM_PLATE: 'INSTALL_TRIM_PLATE',
    MOUNT_BASE: 'MOUNT_BASE',
    CONNECT_WIRES: 'CONNECT_WIRES',
    RESTORE_POWER: 'RESTORE_POWER',
    CHECK_LED: 'CHECK_LED',
    LED_ERROR: 'LED_ERROR',
    ATTACH_DISPLAY: 'ATTACH_DISPLAY',
    ON_SCREEN_INSTRUCTIONS: 'ON_SCREEN_INSTRUCTIONS',
    SETUP_COMPLETE: 'SETUP_COMPLETE',
};


const TERMINAL_GROUPS_MAIN = [
    { label: 'Power', terminals: ['R', 'Rh', 'Rc'] },
    { label: 'Common', terminals: ['C'] },
    { label: 'Heating', terminals: ['W or W1', 'W2'] },
    { label: 'Cooling', terminals: ['Y or Y1', 'Y2'] },
    { label: 'Fan', terminals: ['G or F'] },
    { label: 'Heat Pump', terminals: ['O', 'B', 'O/B'] },
];

const TERMINAL_GROUP_ACCESSORIES = {
    label: 'Other / Accessories',
    terminals: ['Aux', 'E', 'W3', 'Z', 'L', 'K', 'dh', 'T', 'COM', 'S1 or S2 or S3', 'X', 'GND', 'ODT', 'Other'],
};


const InstallationGuide = ({ onBack, onViewSystem , isIQAirDisplay,handleClick,isDarkMode }) => {
    const classes = makeStyle();
    const [currentStep, setCurrentStep] = useState(STEPS.INTRO);
    const [history, setHistory] = useState([]);
    const [capturedImage, setCapturedImage] = useState(null);
    const [capturedImageName, setCapturedImageName] = useState(null);
    const [selectedTerminals, setSelectedTerminals] = useState([]);
    const [showAccessories, setShowAccessories] = useState(false);
    const [wiringMap, setWiringMap] = useState([]);
    const [isHeatPump, setIsHeatPump] = useState(null);

    const goTo = (step) => {
        setHistory(prev => [...prev, currentStep]);
        setCurrentStep(step);
    };

    const goBack = () => {
        if (history.length === 0) {
            onBack();
            return;
        }
        const prev = history[history.length - 1];
        setHistory(h => h.slice(0, -1));
        setCurrentStep(prev);
    };

    const headerTitle = currentStep === STEPS.SETUP_COMPLETE
        ? I18n.t('mobile.AirDeviceProvisioning.completeSystemSetup', { defaultValue: 'Complete System setup' })
        : I18n.t('mobile.AirDeviceProvisioning.installIQAirTitle', { defaultValue: 'Install IQ Air' });

    // Steps 1-3 always completed; wrench gray (pending) throughout guide, completed only on SETUP_COMPLETE
    const isComplete = currentStep === STEPS.SETUP_COMPLETE;
    const activeStep = isComplete ? 4 : 3;

    // ── Camera / photo capture ────────────────────────────────────────────────
    const captureImage = () => {
        if (window.navigator && window.navigator.camera) {
            window.navigator.camera.getPicture(
                (imageData) => {
                    setCapturedImage('data:image/jpeg;base64,' + imageData);
                    const timestamp = Date.now();
                    setCapturedImageName(`img_${timestamp}.jpg`);
                },
                (err) => console.warn('Camera capture error:', err),
                {
                    quality: 70,
                    destinationType: 0,
                    sourceType: 1,
                    encodingType: 0,
                    targetWidth: 600,
                    targetHeight: 600,
                    correctOrientation: true,
                }
            );
        } else {
            document.getElementById('igCaptureInput').click();
        }
    };

    // ── Terminal chip toggle ──────────────────────────────────────────────────
    const toggleTerminal = (t) => {
        setSelectedTerminals(prev =>
            prev.includes(t) ? prev.filter(x => x !== t) : [...prev, t]
        );
    };

    // ── Terminal Continue → routing ───────────────────────────────────────────
    const handleTerminalContinue = () => {
        const result = evaluate(selectedTerminals);
        if (result.screen === 'S3') { goTo(STEPS.UNCOMMON_WIRING); return; }
        if (result.screen === 'S4') { goTo(STEPS.K_TERMINAL); return; }
        if (result.screen === 'S5') { goTo(STEPS.UNRECOGNIZED); return; }
        if (result.wiringMap) setWiringMap(result.wiringMap);
        if (result.screen === 'POWER_PLATE') { goTo(STEPS.POWER_PLATE); return; }
        goTo(STEPS.REMOVE_THERMOSTAT);
    };

    // ── Shared stepper progress steps ────────────────────────────────────────
    const progressSteps = { step1: 100, step2: 100, step3: 100 };

    // ── Render helpers ────────────────────────────────────────────────────────
    const renderStepper = () => {
        if(isIQAirDisplay){
         return null
        }
       return <ProvisionStepper
            key={activeStep}
            activeStep={activeStep}
            progressSteps={progressSteps}
            incomplete={!isComplete}
        />
    }

    const renderImage = (src,darkModeImg=false) => {
        
      return  <Box className={classes.imageWrapper}>
            <Icon src={(darkModeImg ? `${src}Dark` : src) || 'thermostatImage'} alt="Installation" />
        </Box>
    };

    const renderBottomContinue = (onPress, label = 'Continue', disabled = false) => (
        <Box className={classes.buttonContainer}>
            <Button className={classes.primaryButton} onClick={onPress} disabled={disabled}>
                {label}
            </Button>
        </Box>
    );

    const renderYesNo = (onNo, onYes) => (
        <Box className={classes.buttonContainer}>
            <Box className={classes.yesNoRow}>
                <Button className={classes.yesNoButton} onClick={onNo}>
                    {I18n.t('mobile.AirDeviceProvisioning.no', { defaultValue: 'No' })}
                </Button>
                <Button className={classes.yesButton} onClick={onYes}>
                    {I18n.t('mobile.AirDeviceProvisioning.yes', { defaultValue: 'Yes' })}
                </Button>
            </Box>
        </Box>
    );

    const renderBackOnly = () => (
        <Box className={classes.buttonContainer}>
            <Button className={classes.secondaryButton} onClick={goBack}>
                Retry
            </Button>
        </Box>
    );

    const renderRetryAndContactSupport = () => (
        <Box className={classes.buttonContainer}>
            <Button className={classes.yesButton} onClick={goBack}>
                Retry
            </Button>
            <Button className={classes.yesNoButton} onClick={() => window.open(IQ_AIR_CONTACT_SUPPORT, '_blank')}>
                {I18n.t('mobile.AirDeviceProvisioning.contactSupport', { defaultValue: 'Contact Support' })}
            </Button>
        </Box>
    );

    const renderErrorScreen = (title, body, showSupportButton = false) => (
        <>
            <Box className={classes.body}>
                {renderStepper()}
                {renderImage('IgThermostatError')}
                <Typography className={classes.title}>{title}</Typography>
                <Typography className={classes.subtitle}>{body}</Typography>
            </Box>
            {showSupportButton ? renderRetryAndContactSupport() :renderBackOnly()}
        </>
    );

    // ── Screen renderers ──────────────────────────────────────────────────────
    const renderIntro = () => (
        <>
            <Box className={classes.body}>
                {renderStepper()}
                {renderImage('thermostatImage')}
                <Typography className={classes.title}>
                    {I18n.t('mobile.AirDeviceProvisioning.installationOverviewTitle', { defaultValue: 'Installation overview' })}
                </Typography>
                
                <Typography dangerouslySetInnerHTML={{
                    __html: I18n.t('mobile.AirDeviceProvisioning.installationOverviewSubtitleCommon', { defaultValue: 'Tap Start Installation to open step-by-step guide, which will walk you through:' }),
                }} className={`${classes?.subtitle} ${classes?.subtitleSecondary}`}>

                </Typography>
                <ol className={`${classes?.numberedList} ${classes?.numberedListNone}`}>
                    <li dangerouslySetInnerHTML={{__html: I18n.t('mobile.AirDeviceProvisioning.installStep1', { defaultValue: '1. Preparation: Turning off HVAC power and removing your old thermostat.' })}}></li>
                    <li dangerouslySetInnerHTML={{__html: I18n.t('mobile.AirDeviceProvisioning.installStep2', { defaultValue: '2. Hardware Setup: Wiring and mounting your new IQ Air base and display.' })}}></li>
                    <li dangerouslySetInnerHTML={{__html: I18n.t('mobile.AirDeviceProvisioning.installStep3', { defaultValue: '3. Activation: Completing the on-screen digital setup.' }),
                }}></li>
                </ol>
            </Box>
            {renderBottomContinue(() => goTo(STEPS.WHATS_IN_BOX),'Start Installation')}
            
                <Box className={classes.buttonContainer}>
                    <Button className={`${classes?.primaryButton} ${classes?.iqAirDisplayPrimaryButton}`} onClick={()=>goTo(STEPS.ON_SCREEN_INSTRUCTIONS)}>
                      {I18n.t('mobile.AirDeviceProvisioning.alreadyInstalled', { defaultValue: 'Already Installed?' })}
                    </Button>
                </Box>
            
        </>
    );

    const renderWhatsInBox = () => (
        <>
            <Box className={classes.body}>
                {renderStepper()}
                {renderImage('igWhatsInBox')}
                <Typography className={classes.title}>
                    {I18n.t('mobile.AirDeviceProvisioning.whatsInBoxTitle', { defaultValue: "What's in the box" })}
                </Typography>
                <ol className={classes.numberedList}>
                    <li>{I18n.t('mobile.AirDeviceProvisioning.boxItem1', { defaultValue: 'Trim plate' })}</li>
                    <li>{I18n.t('mobile.AirDeviceProvisioning.boxItem2', { defaultValue: 'Base' })}</li>
                    <li>{I18n.t('mobile.AirDeviceProvisioning.boxItem3', { defaultValue: 'Display' })}</li>
                    <li>{I18n.t('mobile.AirDeviceProvisioning.boxItem4', { defaultValue: 'Drywall anchors × 2' })}</li>
                    <li>{I18n.t('mobile.AirDeviceProvisioning.boxItem5', { defaultValue: 'Wall screws × 2' })}</li>
                </ol>
            </Box>
            {renderBottomContinue(() => goTo(STEPS.TOOLS_NEEDED))}
        </>
    );

    const renderToolsNeeded = () => (
        <>
            <Box className={classes.body}>
                {renderStepper()}
                {renderImage('igToolsNeeded')}
                <Typography className={classes.title}>
                    {I18n.t('mobile.AirDeviceProvisioning.toolsNeededTitle', { defaultValue: 'Tools needed' })}
                </Typography>
                <Typography className={classes.subtitle}>
                    {I18n.t('mobile.AirDeviceProvisioning.toolsNeededSubtitle', { defaultValue: 'Have these tools ready for installation:' })}
                </Typography>
                <ol className={classes.numberedList}>
                    <li>{I18n.t('mobile.AirDeviceProvisioning.tool1', { defaultValue: 'Phillips screwdriver' })}</li>
                    <li>{I18n.t('mobile.AirDeviceProvisioning.tool2', { defaultValue: 'Pencil to mark mounting location' })}</li>
                    <li>{I18n.t('mobile.AirDeviceProvisioning.tool3', { defaultValue: 'Power drill with 3/16" drill bit' })}</li>
                    <li>{I18n.t('mobile.AirDeviceProvisioning.tool4', { defaultValue: 'Needle-nose pliers' })}</li>
                    <li>{I18n.t('mobile.AirDeviceProvisioning.tool5', { defaultValue: 'Phone with camera and internet access' })}</li>
                </ol>
            </Box>
            {renderBottomContinue(() => goTo(STEPS.TURN_OFF_HVAC))}
        </>
    );

    const renderTurnOffHvac = () => (
        <>
            <Box className={classes.body}>
                {renderStepper()}
                {renderImage('igTurnOffHvac')}
                <Typography className={classes.title}>
                    {I18n.t('mobile.AirDeviceProvisioning.turnOffHvacTitle', { defaultValue: 'Turn off HVAC power' })}
                </Typography>
                <Typography className={classes.subtitle}>
                    {I18n.t('mobile.AirDeviceProvisioning.turnOffHvacBody', { defaultValue: 'Before checking wiring, turn off HVAC power to avoid shock or system damage.' })}
                </Typography>
                <Typography className={classes.subtitle} style={{ marginTop: '16px' }}>
                    {I18n.t('mobile.AirDeviceProvisioning.turnOffHvacQuestion', { defaultValue: 'Is the thermostat powered off?' })}
                </Typography>
            </Box>
            {renderYesNo(
                () => goTo(STEPS.HVAC_POWER_ERROR),
                () => goTo(STEPS.TAKE_PHOTO)
            )}
        </>
    );

    const renderHvacPowerError = () => renderErrorScreen(
        I18n.t('mobile.AirDeviceProvisioning.doNotProceedTitle', { defaultValue: 'Do not proceed' }),
        I18n.t('mobile.AirDeviceProvisioning.hvacPowerErrorBody', { defaultValue: 'Your HVAC system must be powered off before proceeding.' })
    );

    const renderTakePhoto = () => (
        <>
            <Box className={classes.body}>
                {renderStepper()}
                {renderImage('igTakePhoto')}
                <Typography className={classes.title}>
                    {I18n.t('mobile.AirDeviceProvisioning.takePhotoTitle', { defaultValue: 'Have you taken a photo?' })}
                </Typography>
                <Typography className={classes.subtitle}>
                    {I18n.t('mobile.AirDeviceProvisioning.takePhotoBody', { defaultValue: 'Remove the thermostat from the wall and take a photo of the wires and the terminal labels.' })}
                </Typography>
                {!capturedImage && <Box className={classes.photoHintBox}>
                    <Typography className={classes.photoHintText}>
                        {I18n.t('mobile.AirDeviceProvisioning.takePhotoHint', { defaultValue: 'This photo will help you when you connect the wiring later.' })}
                    </Typography>
                    <Button className={classes.takePhotoBtn} onClick={captureImage}>
                        {I18n.t('mobile.AirDeviceProvisioning.takePhotoBtn', { defaultValue: 'TAKE PHOTO' })}
                    </Button>
                </Box>}
                {capturedImage && (
                    <Box className={classes.capturedThumb}>
                        <Box className={classes.capturedThumbRow}>
                            <Typography className={classes.capturedThumbName}>
                                {capturedImageName?.substring(0, 5) + capturedImageName?.substring(capturedImageName.lastIndexOf('.'))}
                            </Typography>
                            <Button className={classes.closeThumbBtn} onClick={() => { setCapturedImage(null); setCapturedImageName(null); }}>✕</Button>
                        </Box>
                        <img src={capturedImage} alt="captured wiring" className={classes.capturedThumbImg} />
                    </Box>
                )}
                <input
                    id="igCaptureInput"
                    type="file"
                    accept="image/*"
                    capture="environment"
                    style={{ display: 'none' }}
                    onChange={(e) => {
                        const file = e.target.files[0];
                        if (file) {
                            setCapturedImageName(file.name);
                            const reader = new FileReader();
                            reader.onload = (ev) => setCapturedImage(ev.target.result);
                            reader.readAsDataURL(file);
                        }
                    }}
                />
            </Box>
            {renderYesNo(
                () => goTo(STEPS.PHOTO_ERROR),
                () => goTo(STEPS.HIGH_VOLTAGE)
            )}
        </>
    );

    const renderPhotoError = () => renderErrorScreen(
        I18n.t('mobile.AirDeviceProvisioning.doNotProceedTitle', { defaultValue: 'Do not proceed' }),
        I18n.t('mobile.AirDeviceProvisioning.photoErrorBody', { defaultValue: 'It is important that you take a clear photo of your old thermostat wires and terminal labels. This will be crucial while checking the HVAC compatibility in further steps.' })
    );

    const renderHighVoltage = () => (
        <>
            <Box className={classes.body}>
                {renderStepper()}
                {renderImage('igHighVoltage')}
                <Typography className={classes.title}>
                    {I18n.t('mobile.AirDeviceProvisioning.highVoltageTitle', { defaultValue: 'Do you see any of the following on your thermostat or wiring?' })}
                </Typography>
                <ol className={classes.numberedList}>
                    <li>{I18n.t('mobile.AirDeviceProvisioning.highVoltageItem1', { defaultValue: 'Labels that say 120 V and 240 V, or L1/L2' })}</li>
                    <li>{I18n.t('mobile.AirDeviceProvisioning.highVoltageItem2', { defaultValue: 'Stranded wires instead of solid ones' })}</li>
                    <li>{I18n.t('mobile.AirDeviceProvisioning.highVoltageItem3', { defaultValue: 'Thick wires connected with wire nuts' })}</li>
                </ol>
            </Box>
            {renderYesNo(
                () => goTo(STEPS.JUMPER_WIRES),
                () => goTo(STEPS.HIGH_VOLTAGE_ERROR)
            )}
        </>
    );

    const renderHighVoltageError = () => (
        <>
            <Box className={classes.body}>
                {renderStepper()}
                {renderImage('IgThermostatError')}
                <Box className={classes.errorContainer}>
                    <Typography className={classes.title}>
                        {I18n.t('mobile.AirDeviceProvisioning.notCompatibleTitle', { defaultValue: 'Not compatible' })}
                    </Typography>
                    <Typography className={classes.subtitle}>
                        {I18n.t('mobile.AirDeviceProvisioning.highVoltageErrorBody', { defaultValue: 'Your system uses high-voltage wiring. The IQ Air is designed for 24 V systems and cannot be installed on high-voltage circuits.' })}
                    </Typography>
                </Box>
            </Box>
            {renderBackOnly()}
        </>
    );

    const renderJumperWires = () => (
        <>
            <Box className={classes.body}>
                {renderStepper()}
                {renderImage('igJumperWires',isDarkMode)}
                <Typography className={classes.title}>
                    {I18n.t('mobile.AirDeviceProvisioning.jumperWiresTitle', { defaultValue: 'Do you see jumper wires?' })}
                </Typography>
                <Typography className={classes.subtitle}>
                    {I18n.t('mobile.AirDeviceProvisioning.jumperWiresBody', { defaultValue: 'Some thermostats utilize jumper wires to connect two terminals together.' })}
                </Typography>
            </Box>
            {renderYesNo(
                () => goTo(STEPS.DUAL_LABELS),
                () => goTo(STEPS.REMOVE_JUMPERS)
            )}
        </>
    );

    const renderRemoveJumpers = () => (
        <>
            <Box className={classes.body}>
                {renderStepper()}
                {renderImage('igJumperWires',isDarkMode)}
                <Typography className={classes.title}>
                    {I18n.t('mobile.AirDeviceProvisioning.removeJumpersTitle', { defaultValue: 'Remove all jumper wires' })}
                </Typography>
                <Typography className={classes.subtitle}>
                    {I18n.t('mobile.AirDeviceProvisioning.removeJumpersBody', { defaultValue: 'Use a screwdriver to remove the jumper wires. The IQ Air handles this connection internally, so you will not need it.' })}
                </Typography>
            </Box>
            {renderBottomContinue(() => goTo(STEPS.DUAL_LABELS))}
        </>
    );

    const renderDualLabels = () => (
        <>
            <Box className={classes.body}>
                {renderStepper()}
                {renderImage('igDualLabels',isDarkMode)}
                <Typography className={classes.title}>
                    {I18n.t('mobile.AirDeviceProvisioning.dualLabelsTitle', { defaultValue: 'Do you see two sets of labels on your old thermostat?' })}
                </Typography>
                <Typography className={classes.subtitle}>
                    {I18n.t('mobile.AirDeviceProvisioning.dualLabelsBody', { defaultValue: 'Some terminals have two sets of labels, one for conventional and one for heat pump.' })}
                </Typography>
            </Box>
            {renderYesNo(
                () => goTo(STEPS.TERMINAL_SELECTION),
                () => goTo(STEPS.HEAT_PUMP_CHECK)
            )}
        </>
    );

    const renderHeatPumpCheck = () => (
        <>
            <Box className={classes.body}>
                {renderStepper()}
                {renderImage('igHeatPumpCheck')}
                <Typography className={classes.title}>
                    {I18n.t('mobile.AirDeviceProvisioning.heatPumpCheckTitle', { defaultValue: 'Do you have a Heat Pump?' })}
                </Typography>
            </Box>
            {renderYesNo(
                () => { setIsHeatPump(false); goTo(STEPS.TERMINAL_SELECTION); },
                () => { setIsHeatPump(true); goTo(STEPS.TERMINAL_SELECTION); }
            )}
        </>
    );

    const renderTerminalSelection = () => (
        <>
            <Box className={classes.body}>
                {renderStepper()}
                {capturedImage
                    ? <img src={capturedImage} alt="wiring" className={classes.capturedPhotoFull} />
                    : renderImage()
                }
                <Typography className={classes.title}>
                    {I18n.t('mobile.AirDeviceProvisioning.terminalSelectionTitle', { defaultValue: 'Select your terminals' })}
                </Typography>
                <Typography className={classes.subtitle}>
                    {isHeatPump === true 
                        ? I18n.t('mobile.AirDeviceProvisioning.terminalSelectionSubtitleHeatPump', { defaultValue: 'As you have a Heat Pump, follow the Heat Pump labels and tap every terminal with a wire connected.' })
                        : isHeatPump === false
                        ? I18n.t('mobile.AirDeviceProvisioning.terminalSelectionSubtitleConventional', { defaultValue: 'As you have a Conventional system, follow the Conventional labels and tap every terminal with a wire connected.' })
                        : I18n.t('mobile.AirDeviceProvisioning.terminalSelectionSubtitle', { defaultValue: 'Tap every terminal letter that has a wire connected.' })
                    }
                </Typography>
                <Box className={classes.chipsSection}>
                    <Box className={classes.terminalGroupsGrid}>
                        {TERMINAL_GROUPS_MAIN.map(group => (
                            <Box key={group.label} className={classes.terminalGroupCard}>
                                <Typography className={classes.chipGroupLabel}>{group.label}</Typography>
                                <Box className={classes.chipCircleRow}>
                                    {group.terminals.map(t => (
                                        <Box
                                            key={t}
                                            className={classes.chipCircleItem}
                                            onClick={() => toggleTerminal(t)}
                                        >
                                            <Box className={selectedTerminals.includes(t) ? classes.chipCircleSelected : classes.chipCircle}>
                                                {selectedTerminals.includes(t) && (
                                                    <span className={classes.chipCircleCheck}>
                                                        <Icon src='blueTick' />
                                                    </span>
                                                )}
                                            </Box>
                                            <Typography className={classes.chipCircleLabel}>{t}</Typography>
                                        </Box>
                                    ))}
                                </Box>
                            </Box>
                        ))}
                        {showAccessories && (
                            <Box className={`${classes.terminalGroupCard} ${classes.terminalGroupCardFull}`}>
                                <Typography className={classes.chipGroupLabel}>{TERMINAL_GROUP_ACCESSORIES.label}</Typography>
                                <Box className={classes.chipCircleRowGrid}>
                                    {TERMINAL_GROUP_ACCESSORIES.terminals.map(t => (
                                        <Box
                                            key={t}
                                            className={classes.chipCircleItem}
                                            onClick={() => toggleTerminal(t)}
                                        >
                                            <Box className={selectedTerminals.includes(t) ? classes.chipCircleSelected : classes.chipCircle}>
                                                {selectedTerminals.includes(t) && (
                                                    <span className={classes.chipCircleCheck}>
                                                        <Icon src='blueTick' />
                                                    </span>
                                                )}
                                            </Box>
                                            <Typography className={classes.chipCircleLabel}>{t}</Typography>
                                        </Box>
                                    ))}
                                </Box>
                            </Box>
                        )}
                    </Box>
                    <button className={classes.showMoreBtn} onClick={() => setShowAccessories(v => !v)}>
                        {showAccessories
                            ? I18n.t('mobile.AirDeviceProvisioning.showFewerTerminals', { defaultValue: '- Show fewer terminals' })
                            : I18n.t('mobile.AirDeviceProvisioning.showMoreTerminals', { defaultValue: '+ Show more terminals' })
                        }
                    </button>
                </Box>
            </Box>
            {renderBottomContinue(handleTerminalContinue, 'Continue', selectedTerminals.length === 0)}
        </>
    );

    const renderUncommonWiring = () => renderErrorScreen(
        I18n.t('mobile.AirDeviceProvisioning.uncommonWiringTitle', { defaultValue: 'Uncommon wiring detected' }),
        I18n.t('mobile.AirDeviceProvisioning.uncommonWiringBody', { defaultValue: "We couldn't match your wiring to a standard HVAC configuration. Please review your wiring or contact our support team for help." }),
        true
    );

    const renderKTerminal = () => renderErrorScreen(
        I18n.t('mobile.AirDeviceProvisioning.kTerminalTitle', { defaultValue: 'Professional rewiring required' }),
        I18n.t('mobile.AirDeviceProvisioning.kTerminalBody', { defaultValue: 'Your thermostat has a K terminal, indicating a Honeywell wire-saving module. A technician will need to rewire to standard terminals before installing the IQ Air.' }),
        true
    );

    const renderUnrecognized = () => renderErrorScreen(
        I18n.t('mobile.AirDeviceProvisioning.unrecognizedTitle', { defaultValue: 'Unrecognized terminal' }),
        I18n.t('mobile.AirDeviceProvisioning.unrecognizedBody', { defaultValue: "We couldn't identify all of your terminals. Please contact our support team to guide you through the rest of the installation process." }),
        true
    );

    const renderPowerPlate = () => (
        <>
            <Box className={classes.body}>
                {renderStepper()}
                {renderImage('igPowerPlate')}
                <Typography className={classes.title}>
                    {I18n.t('mobile.AirDeviceProvisioning.powerPlateTitle', { defaultValue: 'Power Plate required' })}
                </Typography>
                <Typography dangerouslySetInnerHTML={{
                    __html: I18n.t('mobile.AirDeviceProvisioning.powerPlateBody', { defaultValue: 'Your wiring configuration requires the Power Plate accessory. Follow the steps in the installation guide.' }),
                }} className={classes.subtitle}>

                </Typography>
            </Box>
            {renderBackOnly()}
        </>
    );

    const renderRemoveThermostat = () => (
        <>
            <Box className={classes.body}>
                {renderStepper()}
                {renderImage('igRemoveThermostat')}
                <Typography className={classes.title}>
                    {I18n.t('mobile.AirDeviceProvisioning.removeThermostatTitle', { defaultValue: 'Remove the old thermostat' })}
                </Typography>
                <ol className={classes.numberedList}>
                    <li>{I18n.t('mobile.AirDeviceProvisioning.removeThermostatStep1', { defaultValue: 'Loosen each terminal with a screwdriver and carefully pull the wires free.' })}</li>
                    <li>{I18n.t('mobile.AirDeviceProvisioning.removeThermostatStep2', { defaultValue: 'Unscrew the old thermostat base from the wall and set it aside.' })}</li>
                </ol>
            </Box>
            {renderBottomContinue(() => goTo(STEPS.INSTALL_TRIM_PLATE))}
        </>
    );

    const renderInstallTrimPlate = () => (
        <>
            <Box className={classes.body}>
                {renderStepper()}
                {renderImage('igTrimPlate')}
                <Typography className={classes.title}>
                    {I18n.t('mobile.AirDeviceProvisioning.trimPlateTitle', { defaultValue: 'Optional: Install the trim plate' })}
                </Typography>
                <Typography className={classes.subtitle}>
                    {I18n.t('mobile.AirDeviceProvisioning.trimPlateBody', { defaultValue: 'If your wall has marks or holes from the old thermostat, attach the trim plate(1) to cover them before mounting.' })}
                </Typography>
            </Box>
            {renderBottomContinue(() => goTo(STEPS.MOUNT_BASE))}
        </>
    );

    const renderMountBase = () => (
        <>
            <Box className={classes.body}>
                {renderStepper()}
                {renderImage('igMountBase')}
                <Typography className={classes.title}>
                    {I18n.t('mobile.AirDeviceProvisioning.mountBaseTitle', { defaultValue: 'Mount the base to the wall' })}
                </Typography>
                <Typography className={classes.subtitle}>
                    {I18n.t('mobile.AirDeviceProvisioning.mountBaseBody', { defaultValue: 'If needed, drill two holes with a 3/16" bit and insert the drywall anchors before securing the base.' })}
                </Typography>
            </Box>
            {renderBottomContinue(() => goTo(STEPS.CONNECT_WIRES))}
        </>
    );

    const renderConnectWires = () => (
        <>
            <Box className={classes.body}>
                {renderStepper()}
                {capturedImage
                    ? <img src={capturedImage} alt="wiring" className={classes.capturedPhotoFull} />
                    : renderImage()
                }
                <Typography className={classes.title}>
                    {I18n.t('mobile.AirDeviceProvisioning.connectWiresTitle', { defaultValue: 'Connect your wires' })}
                </Typography>
                <Typography className={classes.subtitle}>
                    {I18n.t('mobile.AirDeviceProvisioning.connectWiresBody', { defaultValue: 'Match each wire from your old thermostat to the corresponding terminal on the IQ Air.' })}
                </Typography>
                {wiringMap.length > 0 && (
                    <Box className={classes.wiringTable}>
                        <Box className={`${classes.wiringTableHeader} ${isDarkMode ? classes.wiringArrowDarkColor : ''}`}>
                            <Typography className={classes.wiringColLabel}>
                                {I18n.t('mobile.AirDeviceProvisioning.oldTerminal', { defaultValue: 'Old terminal' })}
                            </Typography>
                            <span className={`${classes.wiringArrow}`}><Icon src='IgRightArrow' /></span>
                            {/* <Typography className={classes.wiringColLabel} style={{ flex: 0.3 }}> </Typography> */}
                            <Typography className={classes.wiringColLabel}>
                                {I18n.t('mobile.AirDeviceProvisioning.iqAirTerminal', { defaultValue: 'IQ Air terminal' })}
                            </Typography>
                        </Box>
                        {wiringMap.map((row, i) => (
                            <Box key={i} className={` ${classes.wiringRow} ${isDarkMode ? classes.wiringArrowDarkColor : ''}`}>
                                <span className={classes.wiringChipOld}>{row.old}</span>
                                <span className={`${classes.wiringArrow}`}><Icon src='IgRightArrow' /></span>
                                {row.action === 'tape-off'
                                    ? <span className={`${classes.wiringChipNew} ${classes.tapeOff}`}>Tape off</span>
                                    : <span className={classes.wiringChipNew}>{row.nw}</span>
                                }
                            </Box>
                        ))}
                    </Box>
                )}
            </Box>
            {renderBottomContinue(() => goTo(STEPS.RESTORE_POWER))}
        </>
    );

    const renderRestorePower = () => (
        <>
            <Box className={classes.body}>
                {renderStepper()}
                {renderImage('igRestorePower')}
                <Typography className={classes.title}>
                    {I18n.t('mobile.AirDeviceProvisioning.restorePowerTitle', { defaultValue: 'Restore power to your HVAC' })}
                </Typography>
                <Typography dangerouslySetInnerHTML={{__html: I18n.t('mobile.AirDeviceProvisioning.restorePowerText', { defaultValue: 'After all wires are inserted,restore power to the HVAC system.'})}} className={classes.subtitle}></Typography>
                
            </Box>
            {renderBottomContinue(() => goTo(STEPS.CHECK_LED))}
        </>
    );

    const renderCheckLed = () => (
        <>
            <Box className={classes.body}>
                {renderStepper()}
                {renderImage('igCheckLed')}
                <Typography className={classes.title}>
                    {I18n.t('mobile.AirDeviceProvisioning.checkLedTitle', { defaultValue: 'Is the status LED lighting up?' })}
                </Typography>
                <Typography dangerouslySetInnerHTML={{__html: I18n.t('mobile.AirDeviceProvisioning.ledText', { defaultValue: 'Verify that the status LED on the <br/>base is on, confirming 24 VAC power.'})}} className={classes.subtitle}>
                    
                </Typography>
            </Box>
            {renderYesNo(
                () => goTo(STEPS.LED_ERROR),
                () => goTo(STEPS.ATTACH_DISPLAY)
            )}
        </>
    );

    const renderLedError = () => (
        <>
            <Box className={classes.body}>
                {renderStepper()}
                {renderImage('IgTurnOnHvacError')}
                <Typography className={classes.title}>
                    {I18n.t('mobile.AirDeviceProvisioning.ledErrorTitle', { defaultValue: "Status LED isn't lighting up?" })}
                </Typography>
                <Typography className={classes.subtitle}>
                    {I18n.t('mobile.AirDeviceProvisioning.ledErrorFollowSteps', { defaultValue: 'Follow these steps:' })}
                </Typography>
                <ol className={classes.numberedList} style={{padding: '0 62px'}}>
                    <li>{I18n.t('mobile.AirDeviceProvisioning.ledErrorStep1', { defaultValue: 'Turn off HVAC power' })}</li>
                    <li>{I18n.t('mobile.AirDeviceProvisioning.ledErrorStep2', { defaultValue: 'Verify RH and C wires are securely inserted into the appropriate terminal' })}</li>
                    <li>{I18n.t('mobile.AirDeviceProvisioning.ledErrorStep3', { defaultValue: 'RH and C wires are required. If there is only a single R wire at the wall, use RH. (RC will not supply power to the thermostat)' })}</li>
                    <li>{I18n.t('mobile.AirDeviceProvisioning.ledErrorStep4', { defaultValue: 'Restore power to the HVAC system' })}</li>
                </ol>
                <Typography className={classes.subtitle}>
                    {I18n.t('mobile.AirDeviceProvisioning.ledErrorContactNote', { defaultValue: 'If the Status LED is still not lighting up, contact our Support.' })}
                </Typography>
            </Box>
            {renderRetryAndContactSupport()}
        </>
    );

    const renderAttachDisplay = () => (
        <>
            <Box className={classes.body}>
                {renderStepper()}
                {renderImage('igAttachDisplay')}
                <Typography className={classes.title}>
                    {I18n.t('mobile.AirDeviceProvisioning.attachDisplayTitle', { defaultValue: 'Attach the display' })}
                </Typography>
                <Typography className={classes.subtitle}>
                    {I18n.t('mobile.AirDeviceProvisioning.attachDisplayBody', { defaultValue: 'Align the display with the backplate and press gently until it clicks into place.' })}
                </Typography>
            </Box>
            {renderBottomContinue(() => goTo(STEPS.ON_SCREEN_INSTRUCTIONS))}
        </>
    );

    const renderOnScreenInstructions = (clickFunc) => (
        <>
            <Box className={classes.body}>
                {renderStepper()}
                {renderImage('IgSetupComplete')}
                <Typography className={classes.title}>
                    {I18n.t('mobile.AirDeviceProvisioning.onScreenInstructionsTitle', { defaultValue: 'Follow the on-screen instructions' })}
                </Typography>
               {isIQAirDisplay ? 
              <Box className={classes?.IQAirDisplayBox}>
                  <Typography className={classes?.subtitle}>
                    {I18n.t('mobile.AirDeviceProvisioning.iqAirDisplayZwPairing', { defaultValue: 'After powering on, IQ Air (Secondary) will walk you through the setup process. You\'ll also need to connect it to the IQ Air (Primary) to control it from the Enlighten app.' })}
                  </Typography>
                  <Typography className={`${classes?.subtitle} ${classes?.iqAirDisplaySubtitle}`}>
                    {I18n.t('mobile.AirDeviceProvisioning.followTheseSteps', { defaultValue: 'IQ Air (Secondary) will prompt you to begin Z-Wave pairing. Complete these steps to connect your units:' })}
                  </Typography>
                  <ol className={classes?.numberedList}>
                    <li dangerouslySetInnerHTML={{__html: I18n.t('mobile.AirDeviceProvisioning.iqAirDisplayStep1', { defaultValue: 'On IQ Air (Secondary), Tap Add Device during setup, or go to: Menu → Installer → Z-Wave → Add to Network' })}}></li>
                    <li dangerouslySetInnerHTML={{__html: I18n.t('mobile.AirDeviceProvisioning.iqAirDisplayStep2', { defaultValue: 'On IQ Air (Primary), navigate to:' })}}></li>
                    <li dangerouslySetInnerHTML={{__html: I18n.t('mobile.AirDeviceProvisioning.iqAirDisplayStep3', { defaultValue: 'Menu → Installer → Smart Home → Add Device' })}}></li>
                  </ol>
                  <Typography className={classes?.subtitle}>
                    {I18n.t('mobile.AirDeviceProvisioning.iqAirDisplaySetupCompleteNote', { defaultValue: 'Pairing is complete when your IQ Air confirms the device has been added.' })}
                  </Typography>
                </Box>
               : <Typography className={classes.subtitle}>
                    {I18n.t('mobile.AirDeviceProvisioning.onScreenInstructionsBody', { defaultValue: 'After powering on, IQ Air will walk you through the setup process. Setup is complete when you reach the thermostat\'s home screen.' })}
                </Typography>}
            </Box>
            {renderBottomContinue(() => {
                if (isIQAirDisplay) {
                    if (typeof clickFunc === 'function') {
                        return clickFunc(PAGES.LINK_HVAC_TO_THERMOSTAT);
                    }
                   
                }
                return goTo(STEPS.SETUP_COMPLETE);
            })}
           
        </>
    );

    const renderSetupComplete = () => (
        <>
            <Box className={classes.body}>
                {renderStepper()}
                {renderImage('systemSetupSuccess')}
                <Typography className={classes.title}>
                    {I18n.t('mobile.AirDeviceProvisioning.setupCompleteTitle', { defaultValue: 'IQ Air (Primary) is successfully installed' })}
                </Typography>
                <Box className={classes.photoHintBox}>
                    <Typography className={classes.subtitle}>
                        For improved connectivity, add Wi-Fi. On the IQ Air display, go to <span style={{fontWeight:'500'}}>Menu &gt; Wi-Fi</span> and enter your credentials.
                    </Typography>
                </Box>
            </Box>
            <Box className={classes.buttonContainer}>
                <Button className={classes.primaryButton} onClick={onViewSystem}>
                    {I18n.t('mobile.AirDeviceProvisioning.viewSystemBtn', { defaultValue: 'View System' })}
                </Button>
            </Box>
        </>
    );

    // ── Screen dispatch ───────────────────────────────────────────────────────
    const renderContent = (handleClick) => {
        switch (currentStep) {
            case STEPS.INTRO: return renderIntro();
            case STEPS.WHATS_IN_BOX: return renderWhatsInBox();
            case STEPS.TOOLS_NEEDED: return renderToolsNeeded();
            case STEPS.TURN_OFF_HVAC: return renderTurnOffHvac();
            case STEPS.HVAC_POWER_ERROR: return renderHvacPowerError();
            case STEPS.TAKE_PHOTO: return renderTakePhoto();
            case STEPS.PHOTO_ERROR: return renderPhotoError();
            case STEPS.HIGH_VOLTAGE: return renderHighVoltage();
            case STEPS.HIGH_VOLTAGE_ERROR: return renderHighVoltageError();
            case STEPS.JUMPER_WIRES: return renderJumperWires();
            case STEPS.REMOVE_JUMPERS: return renderRemoveJumpers();
            case STEPS.DUAL_LABELS: return renderDualLabels();
            case STEPS.HEAT_PUMP_CHECK: return renderHeatPumpCheck();
            case STEPS.TERMINAL_SELECTION: return renderTerminalSelection();
            case STEPS.UNCOMMON_WIRING: return renderUncommonWiring();
            case STEPS.K_TERMINAL: return renderKTerminal();
            case STEPS.UNRECOGNIZED: return renderUnrecognized();
            case STEPS.POWER_PLATE: return renderPowerPlate();
            case STEPS.REMOVE_THERMOSTAT: return renderRemoveThermostat();
            case STEPS.INSTALL_TRIM_PLATE: return renderInstallTrimPlate();
            case STEPS.MOUNT_BASE: return renderMountBase();
            case STEPS.CONNECT_WIRES: return renderConnectWires();
            case STEPS.RESTORE_POWER: return renderRestorePower();
            case STEPS.CHECK_LED: return renderCheckLed();
            case STEPS.LED_ERROR: return renderLedError();
            case STEPS.ATTACH_DISPLAY: return renderAttachDisplay();
            case STEPS.ON_SCREEN_INSTRUCTIONS: return renderOnScreenInstructions(handleClick);
            case STEPS.SETUP_COMPLETE: return renderSetupComplete();
            default: return null;
        }
    };

    return (
        <>
            <Header title={headerTitle} onClick={goBack} />
            <Box className={classes.container}>
                {renderContent(handleClick)}
            </Box>
        </>
    );
};

export default InstallationGuide;
